<ul class="information-list">
  <li>{{retailer.name}}</li>
  <li><br></li>
  <li>{{retailer.streetAddress1}}</li>
  <li><span *ngIf="retailer.addressCity">{{retailer.addressCity}}, </span>{{retailer.state}} {{retailer.addressPostalCode}}</li>
</ul>
